import { Alert } from '@mantine/core'
import { IconExclamationCircle } from '@tabler/icons-react'
import { UseMutationResult } from '@tanstack/react-query'
import { getErrorMessage, QueryError } from 'errors'

type Props = {
  mutation: UseMutationResult<any, QueryError, any>
}

export default function ErrorAlert({ mutation }: Props) {
  if (!mutation.isError) {
    return null
  }
  return (
    <Alert variant="light" color="red" icon={<IconExclamationCircle />} mb="md">
      {getErrorMessage(mutation.error)}
    </Alert>
  )
}
